import { logoutUser } from '../redux/authenticationSlice';
import store from '../store';
import axios from 'axios';
import { useNavigate } from 'react-router-dom';

export const axiosAuth = axios.create({
   
});

export const axiosNoAuth = axios.create({
   
});


axiosNoAuth.interceptors.request.use((config) => {
    console.log("config", config?.url)
    
    // Add URL as a parameter to all requests
    if (config?.url) {
        // For GET requests, add URL as query parameter
        if (config.method === 'get') {
            config.params = {
                ...config.params,
                request_url: `Personalized:${config.url}`
            };
        } 
        // For POST/PUT/PATCH requests, add URL to request body
        else if (['post', 'put', 'patch'].includes(config.method)) {
            if (config.data) {
                // If data is an object, add URL to it
                if (typeof config.data === 'object' && !Array.isArray(config.data)) {
                    config.data.request_url = `Personalized:${config.url}`;
                } else {
                    // If data is not an object, wrap it
                    config.data = {
                        ...config.data,
                        request_url: `Personalized:${config.url}`
                    };
                }
            } else {
                // If no data exists, create it
                config.data = {
                    request_url: `Personalized:${config.url}`
                };
            }
        }
    }
    
    return config;
});

axiosAuth.interceptors.request.use((config) => {
    const token = store.getState().authentication.token;
    if (token) {
        config.headers['Authorization'] = `Bearer ${token}`;
    }
    if (config?.url) {
        // For GET requests, add URL as query parameter
        if (config.method === 'get') {
            config.params = {
                ...config.params,
                request_url: `Personalized:${config.url}`
            };
        } 
        // For POST/PUT/PATCH requests, add URL to request body
        else if (['post', 'put', 'patch'].includes(config.method)) {
            if (config.data) {
                // If data is an object, add URL to it
                if (typeof config.data === 'object' && !Array.isArray(config.data)) {
                    config.data.request_url = `Personalized:${config.url}`;
                } else {
                    // If data is not an object, wrap it
                    config.data = {
                        ...config.data,
                        request_url: `Personalized:${config.url}`
                    };
                }
            } else {
                // If no data exists, create it
                config.data = {
                    request_url: `Personalized:${config.url}`
                };
            }
        }
    }
    return config;
});

axiosAuth.interceptors.response.use(
    (response) => response,
    async (error) => {
        const { status } = error.response;
        if (status === 401) {
            // Token expired or unauthorized, handle the logout and redirect to login page
            await store.dispatch(logoutUser());
            const navigate = useNavigate() // Dispatch a logout action to clear the token from the store
            // Redirect to the login page
            navigate('/welcome'); // You can use your preferred method of navigation here
    }
        return Promise.reject(error);
});